import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=f0c6a43c&scoped=true&"
import script from "./BaseTag.vue?vue&type=script&lang=js&"
export * from "./BaseTag.vue?vue&type=script&lang=js&"
import style0 from "./BaseTag.vue?vue&type=style&index=0&id=f0c6a43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c6a43c",
  null
  
)

export default component.exports